import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "absolute right-[-140px] top-15 z-50 rounded-lg bg-slate-100 p-2 text-black shadow-lg" }
const _hoisted_2 = ["onClick"]

import {
  computed,
} from 'vue';
import {
  supportMenuList,
} from '@/helpers';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportMenuList',
  setup(__props) {

const authStore = useStore.auth;
const utilStore = useStore.util;
const conversationThreadStore = useStore.conversationThread;
const conversationHistoryStore = useStore.conversationHistory;

const phoneNo = computed(() => !!authStore.company?.contactSettings?.phoneNo);
const finalSupportMenuList = computed(() => supportMenuList.filter((item) => !(item.id === 1 && !phoneNo.value)));

function handleContact(supportId: number): void {
  utilStore.isSupportOn = true;
  utilStore.supportId = supportId;
  utilStore.isLeftNavigationMenuOn = false;
  conversationHistoryStore.showHistoryList = false;

  conversationThreadStore.messages = [];

  if (supportId !== 3) {
    conversationThreadStore.uuid = '';
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalSupportMenuList.value, (support, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "rounded-lg px-3 py-1 transition-colors hover:bg-gray-300 hover:transition"
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "flex w-36 items-center gap-4",
            onClick: ($event: any) => (handleContact(support.id))
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(support.icon), { class: "size-5 stroke-2 text-blue-1" })),
            _createTextVNode(" " + _toDisplayString(support.text), 1)
          ], 8, _hoisted_2)
        ]))
      }), 128))
    ])
  ]))
}
}

})